import { useEffect, useState } from 'react';
import { KpiSettings, emptyKpiSettings } from '../interfaces/settings';
import { getKpiSettings } from '../services/settings';

export function useKpiLabels() {
    const [kpiLabels, setKpiLabels] = useState<KpiSettings>(emptyKpiSettings);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getKpiSettings()
            .then((response: any) => {
                if (response.data.status === '1') {
                    setKpiLabels(response.data.data);
                }
                setLoaded(true);
            })
            .catch((error: any) => {
                console.log(error);
                setLoaded(true);
            });
    }, []);

    return { kpiLabels, loaded };
}
